import React from 'react'
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Breadcrumbs from '../Components/banner/New-banner';
import Changepass from '../Components/User-Dashboard/Changepass';
function ChangePasswordDash() {
    return (
        <>
            <Combaintop />
            <Breadcrumbs />
            <Changepass />
            <Combainbottom />
        </>
    )
}

export default ChangePasswordDash;